import { FC } from 'react';
// components
import SweetenerComponent from 'components/main/SweetenerComponent/Edit';

const EditSweetenerComponent: FC = () => <SweetenerComponent />;

export default EditSweetenerComponent;
